module.exports = __webpack_public_path__ + "static/harpy-6fe374199850e823cc2f02e16965d174.jpg";